// extracted by mini-css-extract-plugin
export var chevron = "_ij-2";
export var chevronRotated = "_ij-3";
export var header = "_ij-1";
export var section = "_ij-0";